import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pgo-callout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pgo-callout.html',
  styleUrl: './pgo-callout.scss'
})
export class PgoCallout {
  @Input() variant: 'info' | 'success' | 'warning' | 'danger' | 'neutral' | 'primary' = 'info';
  @Input() title?: string;
  @Input() dismissible: boolean = false;
  @Input() bordered: boolean = true;
  @Input() outline: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Output() dismissed = new EventEmitter<void>();

  isVisible: boolean = true;

  get calloutClasses(): string {
    const classes = ['pgo-callout', `pgo-callout-${this.variant}`, `pgo-callout-${this.size}`];

    if (this.bordered) {
      classes.push('pgo-callout-bordered');
    }

    if (this.outline) {
      classes.push('pgo-callout-outline');
    }

    return classes.join(' ');
  }

  onDismiss(): void {
    this.isVisible = false;
    this.dismissed.emit();
  }
}
